import React, { useMemo } from 'react';
import { DepartmentQueryData } from '@area-restrita/api-client/model/departmentQueryData';
import { useGetCompanyDepartmentsInfinite } from '@area-restrita/api-client/endpoints/departments/departments.gen';

import Select, { ISelectProps, SelectOption } from '../Select';

const toSelectOption = (department: DepartmentQueryData): SelectOption => ({
  label: department.name,
  value: department.id,
});

type ICompanyDepartmentSelectorProps = Omit<ISelectProps, 'options'>;

const CompanyDepartmentSelector: React.FC<ICompanyDepartmentSelectorProps> = (
  props,
) => {
  const query = useGetCompanyDepartmentsInfinite(
    { limit: 100, page: 1 },
    {
      query: {
        getNextPageParam: (lastPage, _, lastPageParam) =>
          lastPage.data.length > 0 ? lastPageParam + 1 : null,
      },
    },
  );

  const departments = useMemo(
    () =>
      query.data?.pages.flatMap<SelectOption>((page) =>
        page.data.map(toSelectOption),
      ) ?? [],
    [query.data],
  );

  return (
    <Select
      {...(props as ISelectProps)}
      options={departments}
      plural="departamentos"
    />
  );
};

export default CompanyDepartmentSelector;
